export default {"src":"/_next/static/media/shopping-cart.217ced78.svg","height":450,"width":450};